import { Scale, FileText, HandCoins, TrendingUp } from "lucide-react";

const points = [
  { icon: FileText, title: "Buyer agents work under separate agreements", body: "Their fee is set between the buyer and their own agent — not automatically your bill." },
  { icon: HandCoins, title: "You can decline, negotiate, or offer a concession", body: "If a buyer asks you to cover it, you treat it like any other ask — same as a repair credit." },
  { icon: TrendingUp, title: "We score every offer by your net at closing", body: "Your Listing Concierge breaks down each offer so you see exactly what lands in your pocket." },
];

const BuyerAgentEducation = () => {
  return (
    <section className="bg-background py-10 md:py-14 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-10 md:gap-14 items-start">
          <div className="space-y-5">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary rounded-full">
              <Scale className="h-4 w-4 text-primary" />
              <span className="text-xs font-medium uppercase tracking-wider text-primary">Post-NAR settlement</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground leading-tight">
              You're no longer required to pay <span className="text-primary">the buyer's agent.</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Since the 2024 NAR settlement, the buyer's agent fee is between the buyer and their agent. As a seller, you have the leverage — and we walk you through every choice so you keep what's yours.
            </p>
            <div className="bg-brand-warm-50 border-l-4 border-primary rounded-r-xl p-5">
              <p className="text-sm text-foreground leading-relaxed">
                <strong>The headline:</strong> our 0.50% covers your listing side. Whatever happens with the buyer's side is negotiable — and you're in control.
              </p>
            </div>
          </div>

          <div className="space-y-4">
            {points.map(({ icon: Icon, title, body }) => (
              <div key={title} className="bg-brand-warm-50 border border-border rounded-2xl p-6 hover:bg-background hover:border-primary/40 transition-colors">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 inline-flex p-2.5 bg-card rounded-xl border border-border">
                    <Icon className="h-5 w-5 text-primary" strokeWidth={1.75} />
                  </div>
                  <div>
                    <h3 className="font-bold text-foreground mb-1">{title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyerAgentEducation;
